var _defs, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _ellipse, _path, _circle, _circle2, _circle3, _circle4, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGirlOnTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "girl-avatar",
    "data-name": "Girl Avatar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 996.46,
    height: 828.18,
    viewBox: "0 0 996.46 828.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "girl-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff6b9d",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6c63ff",
    stopOpacity: 0.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 200,
    r: 80,
    fill: "#ffdbac",
    stroke: "#d4a574",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,140 Q300,80 380,140 Q400,180 380,220 Q360,240 300,250 Q240,240 220,220 Q200,180 220,140 Z",
    fill: "#8b4513"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,160 Q300,120 360,160",
    stroke: "#654321",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,180 Q300,150 350,180",
    stroke: "#654321",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 190,
    r: 8,
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 190,
    r: 8,
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 188,
    r: 3,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322,
    cy: 188,
    r: 3,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,175 Q280,170 290,175",
    stroke: "#8b4513",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,175 Q320,170 330,175",
    stroke: "#8b4513",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,200 Q295,210 300,220",
    stroke: "#d4a574",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,240 Q300,250 315,240",
    stroke: "#e74c3c",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,280 Q300,260 350,280 L340,450 Q300,470 260,450 Z",
    fill: "url(#girl-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240,
    cy: 350,
    rx: 25,
    ry: 60,
    fill: "#ffdbac",
    transform: "rotate(-20 240 350)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 360,
    cy: 350,
    rx: 25,
    ry: 60,
    fill: "#ffdbac",
    transform: "rotate(20 360 350)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 400,
    r: 20,
    fill: "#ffdbac"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 400,
    r: 20,
    fill: "#ffdbac"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 450,
    width: 25,
    height: 80,
    fill: "#ffdbac"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295,
    y: 450,
    width: 25,
    height: 80,
    fill: "#ffdbac"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292,
    cy: 540,
    rx: 15,
    ry: 8,
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 308,
    cy: 540,
    rx: 15,
    ry: 8,
    fill: "#2c3e50"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 600,
    width: 800,
    height: 20,
    fill: "#8b4513"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 620,
    width: 20,
    height: 100,
    fill: "#654321"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 620,
    width: 20,
    height: 100,
    fill: "#654321"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 550,
    width: 200,
    height: 120,
    fill: "#34495e",
    rx: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 560,
    width: 180,
    height: 100,
    fill: "#2c3e50",
    rx: 5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 570,
    width: 160,
    height: 80,
    fill: "#3498db",
    rx: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 650,
    cy: 580,
    rx: 25,
    ry: 30,
    fill: "#ffffff",
    stroke: "#8b4513",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M675,580 Q680,575 685,580",
    stroke: "#8b4513",
    strokeWidth: 3,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 30,
    fill: "#ff6b9d",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 200,
    r: 40,
    fill: "#6c63ff",
    opacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 400,
    r: 25,
    fill: "#f39c12",
    opacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 500,
    r: 35,
    fill: "#e74c3c",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200,300 Q220,280 240,300 Q260,320 240,340 Q220,360 200,340 Q180,320 200,300",
    fill: "#3498db",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M750,250 Q770,230 790,250 Q810,270 790,290 Q770,310 750,290 Q730,270 750,250",
    fill: "#e67e22",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlOnTable);
export default __webpack_public_path__ + "static/media/girlOnTable.e4ac759557266b32f7558292b936c9d0.svg";
export { ForwardRef as ReactComponent };